import ArbitrumIcon from '../assets/icons/arbitrum.svg'
import BaseIcon from '../assets/icons/base.svg'
import BitcoinIcon from '../assets/icons/btc.svg'
import DogeIcon from '../assets/icons/doge.svg'
import EthereumIcon from '../assets/icons/eth.svg'
import FusionIcon from '../assets/icons/fusion.svg'
import Hyperlogo from '../assets/icons/hyperevm.svg'
import ICPIcon from '../assets/icons/icp.svg'
import OdinIcon from '../assets/icons/odin.svg'
import SolanaIcon from '../assets/icons/sol.svg'

const CHAIN_ICONS = {
  all: FusionIcon,
  icp: ICPIcon,
  eth: EthereumIcon,
  btc: BitcoinIcon,
  sol: SolanaIcon,
  odin: OdinIcon,
  arb: ArbitrumIcon,
  base: BaseIcon,
  doge: DogeIcon,
  hypercore: Hyperlogo,
}

export const getChainIcon = (chain: string) => {
  return CHAIN_ICONS[chain as keyof typeof CHAIN_ICONS]
}
